import { render, staticRenderFns } from "./DtDetailThree.vue?vue&type=template&id=3aa95196&scoped=true"
import script from "./DtDetailThree.vue?vue&type=script&lang=js"
export * from "./DtDetailThree.vue?vue&type=script&lang=js"
import style0 from "./DtDetailThree.vue?vue&type=style&index=0&id=3aa95196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa95196",
  null
  
)

export default component.exports